<template>
    <div class="headerBox">
          <div class="mlogo"><img  src="../assets/logoname.png"/></div>
        <div class="left">
            <DvDecoration8 />
        </div>
        
        <div class="txt" @click="fullScreen">
           歌莉娅会员分析看板
        </div>
        <Decoration5new :color="['#2E51AE','#070919']" class="line" />
      
        <div class="right">
             <DvDecoration8  :reverse="true" />
        </div>
        <div class="time">{{dateFormat(date)}}</div>
    </div>
</template>

<script>
    import Decoration5new from './datav/decoration5new/main';
    import DvDecoration8 from "./vip/decoration8new/main";
  
    export default {
         inject:['root'],
        name: 'TopHeaderVip',
        data () {
            return {
                date: new Date()
            }
        },
        mounted() {
            let _this = this;
            this.timer = setInterval(function() {
            _this.date = new Date();
            });
        },
        beforeDestroy: function() {
            if (this.timer) {
            clearInterval(this.timer);
            }
        },
        methods:{
            fullScreen(){
                 document.querySelector("body").requestFullscreen();
                 this.root.device=this.$isMobile()
             },
            dateFormat:function(date) {
                var year=date.getFullYear();
                var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
                var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
                var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
                var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
                var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
                // 拼接
                return year+"年"+month+"月"+day+"日 "+hours+":"+minutes+":"+seconds;
            }
        },
        components: {
            Decoration5new,
            DvDecoration8          
        }
    }
</script>

<style lang="scss" type="text/scss">
   .headerBox{
       display: flex;
       position: relative;
       width: 100%;
       .mlogo{
           position: absolute;
           font-family: PingFangSC-Semibold;
           font-size: 1.15vw;
           color: #4EADFF;
           letter-spacing: 0;
           text-align: right;
           top:20px;
           left: 18px;
           img{
               width:270px;
               height:35px;
           }
       }
       .left{
         flex: 1;
       }
       .right{
            flex: 1;
       }
       .txt{
           width:25%;
           font-size: 2.5vw;
           text-align: center;
           color: #fff;
       }
       .line{
           position: absolute;
         
            top: 56px;
            width: 100%;
            height: 24px;
       }
       .time{
               position: absolute;
            font-family: PingFangSC-Semibold;
            font-size: 22px;
            color: #fff;
            letter-spacing: 0;
            text-align: right;
            top: 26px;
            right: 22px;
       }
   }
    // #top-header{
    //     position: relative;
    //     width: 100%;
    //     height: 80px;
    //     display: flex;
    //     justify-content: space-between;
    //     flex-shrink: 0;
    //     .dv-decoration-8{
    //         width: 37.7%;
    //         height: 34.3px;
    //     }
    //     .decoration-name{
    //         width: 24.6%;
    //         font-family: PingFangSC-Semibold;
    //         font-size: 50px;
    //         color: #4EADFF;
    //         letter-spacing: 0;
    //         text-align: center;
    //         line-height: 70px;
    //     }
    //     .decoration-time{
    //         position: absolute;
    //         font-family: PingFangSC-Semibold;
    //         font-size: 22px;
    //         color: #4EADFF;
    //         letter-spacing: 0;
    //         text-align: right;  
    //         top: 26px;
    //         right: 22px;
    //     }
    //     .decoration-bottom{
    //         position: absolute;
    //         display: grid;
    //         top: 56px;
    //         width: 100%;
    //         height: 24px;
    //     }
    // }
   
</style>